import { render, staticRenderFns } from "./TJContents.vue?vue&type=template&id=1516f56e&scoped=true&lang=pug&"
import script from "./TJContents.vue?vue&type=script&lang=ts&"
export * from "./TJContents.vue?vue&type=script&lang=ts&"
import style0 from "./TJContents.vue?vue&type=style&index=0&id=1516f56e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516f56e",
  null
  
)

export default component.exports